var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "handle-activity" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "handle-activity-body",
        attrs: {
          "element-loading-text": _vm.loadingText,
          "element-loading-spinner": "el-icon-loading",
        },
      },
      [
        _c(
          "el-form",
          {
            ref: "formRef",
            attrs: {
              model: _vm.form,
              rules: _vm.couponRules,
              "label-width": "150px",
            },
          },
          [
            _c("h3", [_vm._v("基本信息")]),
            _vm._v(" "),
            _c("el-divider"),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "促销名称：", prop: "name" } },
              [
                _c("el-input", {
                  attrs: { clearable: "", placeholder: "请输入" },
                  model: {
                    value: _vm.form.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "name", $$v)
                    },
                    expression: "form.name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  clearable: "",
                  label: "促销时间：",
                  prop: "receiveTime",
                },
              },
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "datetimerange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    "value-format": _vm.timeFormat,
                  },
                  model: {
                    value: _vm.form.receiveTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "receiveTime", $$v)
                    },
                    expression: "form.receiveTime",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "促销详细信息：" } },
              [
                _c(
                  "el-table",
                  {
                    staticClass: "discount-methods",
                    attrs: { data: _vm.tableData },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "优惠方式",
                        align: "center",
                        width: "350",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.$index === 0
                                ? _c(
                                    "el-radio-group",
                                    {
                                      staticClass: "flex",
                                      on: { change: _vm.changeRowA },
                                      model: {
                                        value: scope.row.a,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "a", $$v)
                                        },
                                        expression: "scope.row.a",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: 1 } },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "condition" },
                                            [_vm._v("满")]
                                          ),
                                          _vm._v(" "),
                                          _c("el-input-number", {
                                            attrs: {
                                              min: 0,
                                              placeholder: "请输入",
                                              disabled: scope.row.a !== 1,
                                              controls: false,
                                            },
                                            model: {
                                              value: scope.row.discount,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "discount",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.discount",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "condition" },
                                            [_vm._v("元")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: 2 } },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "condition" },
                                            [_vm._v("每满")]
                                          ),
                                          _vm._v(" "),
                                          _c("el-input-number", {
                                            attrs: {
                                              min: 0,
                                              placeholder: "请输入",
                                              disabled: scope.row.a !== 2,
                                              controls: false,
                                            },
                                            model: {
                                              value: scope.row.discount,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "discount",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.discount",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "condition" },
                                            [_vm._v("元")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: 3 } },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "condition" },
                                            [_vm._v("满")]
                                          ),
                                          _vm._v(" "),
                                          _c("el-input-number", {
                                            attrs: {
                                              min: 0,
                                              placeholder: "请输入",
                                              disabled: scope.row.a !== 3,
                                              controls: false,
                                            },
                                            model: {
                                              value: scope.row.discount,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "discount",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.discount",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "condition" },
                                            [_vm._v("件")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    scope.row.a === 1
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "condition" },
                                              [_vm._v("满")]
                                            ),
                                            _vm._v(" "),
                                            _c("el-input-number", {
                                              attrs: {
                                                min: 0,
                                                placeholder: "请输入",
                                                controls: false,
                                              },
                                              model: {
                                                value: scope.row.discount,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "discount",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.discount",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "condition" },
                                              [_vm._v("元")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.a === 2
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "condition" },
                                              [_vm._v("每满")]
                                            ),
                                            _vm._v(" "),
                                            _c("el-input-number", {
                                              attrs: {
                                                min: 0,
                                                placeholder: "请输入",
                                                controls: false,
                                              },
                                              model: {
                                                value: scope.row.discount,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "discount",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.discount",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "condition" },
                                              [_vm._v("元")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.a === 3
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "condition" },
                                              [_vm._v("满")]
                                            ),
                                            _vm._v(" "),
                                            _c("el-input-number", {
                                              attrs: {
                                                min: 0,
                                                placeholder: "请输入",
                                                controls: false,
                                              },
                                              model: {
                                                value: scope.row.discount,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "discount",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.discount",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "condition" },
                                              [_vm._v("件")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "优惠内容",
                        align: "center",
                        width: "400",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "coupon-info" }, [
                                _c("div", [
                                  scope.$index === 0
                                    ? _c("div", [
                                        scope.row.a !== 3
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "condition" },
                                                  [_vm._v("减")]
                                                ),
                                                _vm._v(" "),
                                                _c("el-input-number", {
                                                  attrs: {
                                                    min: 0,
                                                    placeholder: "请输入",
                                                    controls: false,
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row.discountValue,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "discountValue",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.discountValue",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "condition" },
                                                  [_vm._v("元")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-radio-group",
                                                  {
                                                    staticClass: "flex",
                                                    on: {
                                                      change: _vm.changeRowB,
                                                    },
                                                    model: {
                                                      value: scope.row.b,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "b",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "scope.row.b",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      { attrs: { label: 1 } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "condition",
                                                          },
                                                          [_vm._v("减")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            min: 0,
                                                            disabled:
                                                              scope.row.b !== 1,
                                                            placeholder:
                                                              "请输入",
                                                            controls: false,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .discountValue,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "discountValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.discountValue",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "condition",
                                                          },
                                                          [_vm._v("元")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "el-radio",
                                                      { attrs: { label: 2 } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "condition",
                                                          },
                                                          [_vm._v("打")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            min: 1,
                                                            max: 10,
                                                            disabled:
                                                              scope.row.b !== 2,
                                                            placeholder:
                                                              "请输入",
                                                            controls: false,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .discountValue,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "discountValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.discountValue",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "condition",
                                                          },
                                                          [_vm._v("折")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                      ])
                                    : _c("div", [
                                        scope.row.b === 2
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "condition" },
                                                  [_vm._v("打")]
                                                ),
                                                _vm._v(" "),
                                                _c("el-input-number", {
                                                  attrs: {
                                                    min: 1,
                                                    max: 10,
                                                    placeholder: "请输入",
                                                    controls: false,
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row.discountValue,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "discountValue",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.discountValue",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "condition" },
                                                  [_vm._v("折")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "condition" },
                                                  [_vm._v("减")]
                                                ),
                                                _vm._v(" "),
                                                _c("el-input-number", {
                                                  attrs: {
                                                    min: 0,
                                                    placeholder: "请输入",
                                                    controls: false,
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row.discountValue,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "discountValue",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.discountValue",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "condition" },
                                                  [_vm._v("元")]
                                                ),
                                              ],
                                              1
                                            ),
                                      ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "coupon-info-add" }, [
                                  scope.$index === 0
                                    ? _c("i", {
                                        staticClass: "el-icon-circle-plus icon",
                                        staticStyle: { color: "#00c400" },
                                        on: { click: _vm.changeRow },
                                      })
                                    : _c("i", {
                                        staticClass: "el-icon-remove icon",
                                        staticStyle: { color: "#ff5252" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeRow(scope.$index)
                                          },
                                        },
                                      }),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "最高优惠：", prop: "maxDiscount" } },
              [
                _c("el-input-number", {
                  attrs: { min: 0, placeholder: "请输入", controls: false },
                  model: {
                    value: _vm.form.maxDiscount,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "maxDiscount", $$v)
                    },
                    expression: "form.maxDiscount",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "适用分销客户：",
                  prop: "distributionCustomers",
                },
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    model: {
                      value: _vm.form.distributionCustomers,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "distributionCustomers", $$v)
                      },
                      expression: "form.distributionCustomers",
                    },
                  },
                  _vm._l(_vm.commonData.distributionCustomers, function (item) {
                    return _c(
                      "el-checkbox",
                      { key: item.id, attrs: { label: item.id } },
                      [_vm._v(_vm._s(item.name))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-divider"),
            _vm._v(" "),
            _c("h3", [_vm._v("商品信息")]),
            _vm._v(" "),
            _c("el-divider"),
            _vm._v(" "),
            _c("el-form-item", { attrs: { label: "使用商品" } }, [
              _c(
                "div",
                { staticClass: "use-goods" },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { placeholder: "请选择", clearable: "" },
                      on: { change: _vm.changeApplicableRangeType },
                      model: {
                        value: _vm.form.applicableRangeType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "applicableRangeType", $$v)
                        },
                        expression: "form.applicableRangeType",
                      },
                    },
                    _vm._l(_vm.couponEnum.useGoodsEnum, function (opt) {
                      return _c("el-option", {
                        key: opt.value,
                        attrs: { label: opt.label, value: opt.value },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  [2, 3].includes(_vm.form.applicableRangeType)
                    ? _c(
                        "div",
                        { staticClass: "btns" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.goSelectGoods },
                            },
                            [_vm._v("去选择商品")]
                          ),
                          _vm._v(" "),
                          _c(
                            "ButtonUploadExcelVue",
                            { attrs: { getFileObject: _vm.getFileObject } },
                            [_vm._v("导入商品")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.form.applicableRangeType == 4
              ? _c(
                  "el-form-item",
                  { attrs: { label: "选择分类" } },
                  [
                    _c("el-cascader", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择",
                        options: _vm.commonData.showCateIdOption,
                        props: {
                          children: "child",
                          label: "name",
                          value: "id",
                          multiple: true,
                        },
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.cateIdList,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cateIdList", $$v)
                        },
                        expression: "form.cateIdList",
                      },
                    }),
                  ],
                  1
                )
              : [2, 3].includes(_vm.form.applicableRangeType)
              ? _c("el-form-item", { attrs: { label: "选择商品" } }, [
                  _c(
                    "div",
                    { staticClass: "show-goods" },
                    [
                      _c(
                        "el-table",
                        { attrs: { data: _vm.showTableData.list } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "ID",
                              prop: "id",
                              align: "center",
                              width: "100",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "编码",
                              prop: "skuCode",
                              align: "center",
                              width: "150",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "名称",
                              prop: "skuName",
                              align: "center",
                              "min-width": "100",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "零售价",
                              prop: "otPrice",
                              align: "center",
                              width: "100",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "状态",
                              prop: "listStatus",
                              align: "center",
                              width: "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.listStatus == 1
                                            ? "success"
                                            : "danger",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          { 0: "未上架", 1: "已上架" }[
                                            scope.row.listStatus
                                          ]
                                        )
                                      ),
                                    ]
                                  )
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "品牌",
                              prop: "brandName",
                              align: "center",
                              width: "100",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "供应商",
                              prop: "supplierName",
                              align: "center",
                              width: "200",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              align: "center",
                              width: "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeGoods(scope.$index)
                                          },
                                        },
                                      },
                                      [_vm._v("移除")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-pagination", {
                        staticStyle: {
                          "text-align": "right",
                          "margin-top": "10px",
                        },
                        attrs: {
                          "page-sizes": [20, 40, 60, 80],
                          "page-size": _vm.pageData.limit,
                          "current-page": _vm.pageData.page,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _vm.showTableData.total,
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.handleCurrentChange,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("SelectGoodsVue", {
          ref: "selectGoodsVueRef",
          on: { updateTableData: _vm.updateTableData },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "footer" },
      [
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
          [_vm._v("提交")]
        ),
        _vm._v(" "),
        _c("el-button", { attrs: { type: "info" }, on: { click: _vm.close } }, [
          _vm._v("关闭"),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }